export const WebviewLocalize = {
    btn_done: "Xong",
    login_failed: "Tài khoản hoặc mật khẩu không đúng! Vui lòng thử lại.",
    save_signature_success: "Lưu chữ ký thành công!"
}